import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountIndexResponse } from '@/repositories/generated';
import {
  accountRoleKeys,
  accountStatusKeys,
} from '@/types';

const content: AccountIndexResponse[] = accountRoleKeys.flatMap((role, roleIndex) => accountStatusKeys.map((status, statusIndex) => {
  const id = `${roleIndex}-${statusIndex}`;
  let lockStatus: 'AVAILABLE' | 'LOCKED_NO_LOGIN' | 'LOCKED' = 'AVAILABLE';
  switch ((roleIndex - statusIndex) % 3) {
    case 1:
      lockStatus = 'LOCKED';
      break;
    case 2:
      lockStatus = 'LOCKED_NO_LOGIN';
      break;
    default:
      break;
  }

  return {
    id,
    loginId: `mock${id}`,
    status,
    lockStatus,
    role,
    name: `mock${id} 太郎`,
    email: `mock${id}@example.com`,
    createdAt: '2022-01-01',
  };
}));

const loopContent = [...new Array<string>(50)].map((_, i) => content[i % content.length]);

export const account = http.get(
  createMockEndpoint('/account'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const hasQueryParam = [
      'id',
      'loginId',
      'statuses',
      'lockStatuses',
      'roles',
      'email',
      'acquirerIds',
      'companyIds',
      'shopIds',
      'issuerIds',
      'walletServiceIds',
      'page',
      'size',
      'sort',
    ].some((it) => url.searchParams.getAll(it).length > 0);

    if (hasQueryParam) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
